module.exports = __webpack_public_path__ + "img/factory.6453e86f.svg";